import { render, staticRenderFns } from "./CollapsibleTextField.vue?vue&type=template&id=fca29370"
import script from "./CollapsibleTextField.vue?vue&type=script&lang=js"
export * from "./CollapsibleTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports